import { notify } from "./notify";
import { getAssetMap } from "./getAssetMap";
import { preview } from "./preview";
import { metaFields } from "./../app";
import { playButton } from "./playButton";

export const buildDamBrowser = (assets, button, selectCallback) => {
	// assets here is the damAssets[type] subarray
	let type = button.attr("data-type");
	let browser = button.siblings(".asset_browser");
	browser.find(".dimmer").remove();
	let browserFields = browser.find(".asset_fields_wrapper");
	notify(`Retrieved ${assets.length} assets.`, "info", "top-right");
	button.find(".dimmer").remove();
	let assetMap = getAssetMap(assets, metaFields);
	// retrieve our assets mapped by category

	for (let field in assetMap) {
		let values = [];
		for (let key in assetMap[field]) {
			values.push({
				[key]: assetMap[field][key]
			});
		}
		if (values.length) {
			browserFields.append(`<div id="${field}-${type}-assets" class="dam_browser_field">
                    <div class="dam_browser_field_name bold">${metaFields.find(_field => Object.keys(_field)[0] === field)[field]}</div>
                        <div class="dam_browser_values_wrapper">
                        ${values
							.map(value => {
								let key = Object.keys(value)[0];
								return `<div class="dam_browser_value_wrapper">
                        <div data-expand-target="dam_cards_wrapper" class="dam_browser_value_name">
                            ${key} <span class="arrow" uk-icon="icon:chevron-right"></span>
                        </div>
                        <div class="dam_cards_wrapper closed uk-flex uk-flex-wrap uk-margin-medium">
                            ${value[key].map(thumb => makeCard(thumb, { field: field, value: key })).join("")}
                        </div>
                    </div>`;
							})
							.join("")}
                        </div>
                </div>`);
		}
	}
	// loop through assetMap to place thumbnails
	// in the DOM by field names

	function makeCard(thumb, locator) {
		return `<div class="dam_card uk-margin-small-right" data-id="${thumb.external_id}" data-type="${thumb.type}" data-field="${locator.field}" data-value="${locator.value}">
            <div uk-tooltip="container: .dam_card; title: Name: ${thumb.name}<br/>File: ${thumb.filename}<br/>Created: ${thumb.created}" class="dam_card_thumb_wrapper uk-cover-container">
                <img data-button="preview asset" class="uk-cover" src="${thumb.thumb}" alt="${thumb.name ? thumb.name : thumb.filename}"/>
                ${thumb.type && thumb.type.toLowerCase() === "video" ? playButton(40) : ""}
            </div>
			<div class="uk-text-small">${thumb.name}</div>
            <div class="dam_card_select_wrapper">
                Select <input type="checkbox" value="${thumb.external_id}">
            </div>
        </div>`;
	}
	// end makeCard function

	$("[data-button='preview asset']").on("click", function () {
		let card = $(this).parents(".dam_card");
		preview(
			card.attr("data-type").toLowerCase(),
			assetMap[card.attr("data-field")][card.attr("data-value")].find(item => item.external_id === card.attr("data-id"))
		);
	});
	// preview button click handler

	browserFields.find("[data-expand-target]").on("click", function () {
		let target = $(this).siblings(`.${$(this).attr("data-expand-target")}`);
		if (target.hasClass("closed")) {
			target.removeClass("closed");
			$(this).find(".arrow").attr("uk-icon", "icon:chevron-down");
		} else {
			target.addClass("closed");
			$(this).find(".arrow").attr("uk-icon", "icon:chevron-right");
		}
	});
	// expand section button click handler

	browserFields
		.find(".dam_card_select_wrapper")
		.find("input")
		.on("change", function () {
			let type = $(this).parents(".asset_browser").siblings("[data-type]").attr("data-type");
			let card = $(this).parents(".dam_card");
			let _asset = assetMap[card.attr("data-field")][card.attr("data-value")].find(item => item.external_id === card.attr("data-id"));
			selectCallback($(this), type, _asset);
		});
	// browser select checkbox change handler
};
// end buildDamBrowser function
